module.exports = __webpack_public_path__ + "img/print_cover_b.c8a2fb07.png";